module.exports = __webpack_public_path__ + "assets/dd464b28ac4bc3d57d9336cf31fde8f1.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-latin-ext-500-normal.woff2
// module id = 2640
// module chunks = 121